import { useState, useEffect, useCallback } from 'react'
import { useCadaverService } from 'hooks/useCadaverService'

export const useFormAnalisesInternas = ({ exameNecroscopico, setHideNextButton }) => {
  const cadaverService = useCadaverService()
  const [processandoAnalisesInternas, setProcessandoAnalisesInternas] = useState(false)
  const [isFormAddAnaliseInternaAtivo, setIsFormAddAnaliseInternaAtivo] = useState(false)
  const [idAnaliseInternaSelecionada, setIdAnaliseInternaSelecionada] = useState(-1)
  const [openFichaDeletarAnaliseInterna, setOpenFichaDeletarAnaliseInterna] = useState(false)
  const [idCadaver, setIdCadaver] = useState(null)
  const [analisesInternas, setAnalisesInternas] = useState([])

  const handleBotaoAdicionarAnaliseInterna = useCallback(() => {
    setIsFormAddAnaliseInternaAtivo(true)
    if (setHideNextButton) {
      setHideNextButton(true)
    }
  }, [setHideNextButton])

  const fetchAnalisesInternas = useCallback(async () => {
    if (idCadaver && exameNecroscopico?.id) {
      setProcessandoAnalisesInternas(true)
      try {
        await cadaverService.getAnalisesInternasCadaver(
          exameNecroscopico.id,
          idCadaver,
          setAnalisesInternas,
          setProcessandoAnalisesInternas
        )
      } catch (error) {
        console.error('Error fetching analises internas:', error)
      } finally {
        setProcessandoAnalisesInternas(false)
      }
    }
  }, [exameNecroscopico?.id, idCadaver]) // Excluded cadaverService to prevent loop

  useEffect(() => {
    fetchAnalisesInternas()
  }, [fetchAnalisesInternas])

  useEffect(() => {
    if (
      exameNecroscopico?.id &&
      exameNecroscopico?.exReal?.id &&
      exameNecroscopico?.exReal?.exSol?.id &&
      exameNecroscopico?.exReal?.exSol?.cadavs?.[0]
    ) {
      setIdCadaver(exameNecroscopico.exReal.exSol.cadavs[0].id)
    }
  }, [exameNecroscopico])

  useEffect(() => {
    if (setHideNextButton) {
      setHideNextButton(isFormAddAnaliseInternaAtivo)
    }
  }, [isFormAddAnaliseInternaAtivo, setHideNextButton])

  const clickOpenModalDeletarAnaliseInterna = useCallback((rowData) => {
    setIdAnaliseInternaSelecionada(rowData.id)
    setOpenFichaDeletarAnaliseInterna(true)
  }, [])

  const handleCloseModalDeletarAnaliseInterna = useCallback(() => {
    setIdAnaliseInternaSelecionada(-1)
    setOpenFichaDeletarAnaliseInterna(false)
  }, [])

  const handleDeletarAnaliseInterna = useCallback(async () => {
    if (idAnaliseInternaSelecionada !== -1) {
      setProcessandoAnalisesInternas(true)
      try {
        await cadaverService.excluirAnaliseInternaCadaver(
          idAnaliseInternaSelecionada,
          setProcessandoAnalisesInternas
        )
        await fetchAnalisesInternas()
      } catch (error) {
        console.error('Error deleting analise interna:', error)
      } finally {
        setProcessandoAnalisesInternas(false)
        setOpenFichaDeletarAnaliseInterna(false)
      }
    }
  }, [idAnaliseInternaSelecionada, fetchAnalisesInternas]) // Excluded cadaverService to prevent loop

  return {
    processandoAnalisesInternas,
    isFormAddAnaliseInternaAtivo,
    setIsFormAddAnaliseInternaAtivo,
    openFichaDeletarAnaliseInterna,
    idCadaver,
    analisesInternas,
    setAnalisesInternas,
    setProcessandoAnalisesInternas,
    handleBotaoAdicionarAnaliseInterna,
    clickOpenModalDeletarAnaliseInterna,
    handleCloseModalDeletarAnaliseInterna,
    handleDeletarAnaliseInterna,
  }
}
